import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase.js";

export const AnalyticsEvents = {
    // Resume Actions
    DOWNLOAD_PDF: "download_pdf",
    SAVE_RESUME: "save_resume",
    CREATE_NEW_RESUME: "create_new_resume",

    // AI Actions
    AI_GENERATE_CONTENT: "ai_generate_content",
    AI_ANALYZE_JOB: "ai_analyze_job",

    // Monetization
    VIEW_PRICING: "view_pricing",
    START_CHECKOUT: "start_checkout",
    UPGRADE_SUCCESS: "upgrade_success",

    // Engagement
    LOGIN: "login",
    SIGNUP: "signup",
    SHARE_LINK: "share_link"
};

/**
 * Log a custom event to Firebase Analytics
 * @param {string} eventName - Name of the event (use AnalyticsEvents constant)
 * @param {object} params - Optional parameters (e.g., { value: 9.99, template: 'modern' })
 */
export const trackEvent = (eventName, params = {}) => {
    try {
        if (analytics) {
            logEvent(analytics, eventName, params);
            // Dev logging
            if (process.env.NODE_ENV === 'development') {
                console.log(`[Analytics] ${eventName}:`, params);
            }
        }
    } catch (error) {
        console.warn("Analytics Error:", error);
    }
};
